export default function(o){

  var lang = o.store('lang')

  var backLabel = o.util.getTranslation(o, 'back')
  var rollLabel = o.util.getTranslation(o, 'roll')

  var currentMarker = null

  var backClick = function(){
    history.go(-1)
  }

  var goToRoll = function(){
    var roll = currentMarker.roll
    var start = currentMarker.start
    var startSlug = start.replace(/\:/g, '-')
    history.pushState({}, '', `/roll/${roll}/${startSlug}`)
    o.render(o)
  }

  var setCurrentMarker = function(marker){
    currentMarker = marker
  }

  var div =
    $('<div>')
    .css({
      display: 'flex',
      fontSize: o.fontSizeDef.s
    })
    .append([

      o.component.button(o, backLabel, backClick, 'caretLeft')
      .css({
        flex: '0 0 auto',
        pointerEvents: 'auto',
      }),

      $('<div>')
      .css({
        flex: '1 1 auto',
      }),

      o.component.button(o, rollLabel, goToRoll, 'caretRight', true)
      .css({
        flex: '0 0 auto',
        pointerEvents: 'auto',
      }),

    ])

  div.setCurrentMarker = setCurrentMarker

  return div

}



// WEBPACK FOOTER //
// ./src/client/view/frontend/views/antiArchiveTag/center/center.js